import { Browser } from '@capacitor/browser';
import { isNativePlatform } from './platformService.js';

export function shouldUseNativeInAppBrowser() {
  return isNativePlatform();
}

export async function openInAppBrowser(url) {
  if (!url) return false;

  if (!shouldUseNativeInAppBrowser()) {
    return false;
  }

  await Browser.open({
    url,
    presentationStyle: 'fullscreen',
    toolbarColor: '#ffffff',
  });
  return true;
}
